import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import { GaTrackingEventCategory, GaTrackingEventName, GATrackingEventType } from '../../constants';

export class GaTrackingInstallationServicesDetailsLinksEvent implements GATrackingEvent {
  constructor(private linkLabel: string) {}

  getEventType(): GATrackingEventType {
    return GATrackingEventType.InstallationServicesDetailsLinks;
  }

  getPayload(): GATrackingEventPayload {
    const productPromoViewTracking = {
      category: GaTrackingEventCategory.Navigation,
      label: this.linkLabel,
    };

    return {
      event: GaTrackingEventName.InstallationServicesDetailsLinks,
      gtmCustom: productPromoViewTracking,
    };
  }
}
